import { Text, Tooltip } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { Flag } from '../flag';
import { classes, st } from './country-option.st.css';
const MAX_CHARS = 25;
export function CountryOption({ callingCode, countryName, longCountryCode, clip = true }) {
    if (!clip) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classes.root
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes.flag
        }, /*#__PURE__*/ React.createElement(Flag, {
            longCountryCode: longCountryCode
        })), /*#__PURE__*/ React.createElement(Text, {
            className: classes.text
        }, countryName, /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": "true"
        }, " "), /*#__PURE__*/ React.createElement("span", {
            dir: "ltr",
            lang: "en"
        }, callingCode)));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: st(classes.root, {
            nowrap: clip
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.flag
    }, /*#__PURE__*/ React.createElement(Flag, {
        longCountryCode: longCountryCode
    })), /*#__PURE__*/ React.createElement(Text, {
        className: classes.text,
        "aria-label": countryName
    }, countryName.length > MAX_CHARS ? /*#__PURE__*/ React.createElement(Tooltip, {
        appendTo: "window",
        showDelay: 300,
        content: countryName
    }, `${countryName.substring(0, MAX_CHARS)}...`) : countryName), /*#__PURE__*/ React.createElement(Text, {
        className: classes.text,
        "aria-hidden": "true"
    }, " "), /*#__PURE__*/ React.createElement(Text, {
        className: classes.text
    }, /*#__PURE__*/ React.createElement("span", {
        dir: "ltr",
        lang: "en"
    }, callingCode)));
}

//# sourceMappingURL=country-option.js.map